<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="70%" @opened="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="formRules" ref="formRef" label-width="80px">
      <el-form-item label="标题类型" prop="title_type">
        <el-select v-model="formData.title_type" placeholder="请选择标题类型">
          <el-option label="普通文本" :value="2"></el-option>
          <el-option label="富文本" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标题" prop="name" style="width: 98%;">
        <el-input v-if="formData.title_type === 2" v-model="formData.name" style="width:30%"></el-input>
        <quill-editor v-else ref="titleQuillEditor" v-model="formData.name" :options="titleEditorOption" />
      </el-form-item>
      <el-form-item label="名称" prop="key">
        <el-input v-model="formData.key" style="width:30%"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="formData.type" placeholder="请选择类型">
          <el-option label="富文本" :value="1"></el-option>
          <el-option label="简单文本" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否显示" prop="show">
        <el-radio-group v-model="formData.show">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">不显示</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="显示位置" prop="pos">
        <el-radio-group v-model="formData.pos">
          <el-radio :label="0">默认</el-radio>
          <el-radio :label="1">我的</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="内容" prop="value" style="width: 98%;">
        <el-input v-if="formData.type==2" v-model="formData.value" type="textarea" :rows="3"></el-input>
        <quill-editor v-else ref="myQuillEditor" v-model="formData.value" :options="editorOption" /></el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'config_add',
  props: [
    'visible', 'id'
  ],
  components: {
    'quill-editor': quillEditor
  },
  data () {
    return {
      title: '添加配置',
      formData: {
        name: '',
        key: '',
        title_type: 2,
        type: 1,
        value: '',
        show: 1,
        pos: 0
      },
      formRules: {
        name: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        key: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ]
      },
      titleEditorOption: {
        placeholder: '编辑标题'
      },
      editorOption: {
        placeholder: '编辑配置内容'
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.formRef.resetFields()
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        // 标题类型仅用于当前表单展示，不提交至接口
        const data = Object.assign({}, this.formData)
        delete data.title_type
        if (this.id === 0) {
          this.$emit('add', data)
        } else {
          this.$emit('update', this.id, data)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑配置'
        this.getConfigInfo(this.id)
      }
    },
    async getConfigInfo (id) {
      const res = await this.$http.get('/admin/config/info/' + id)
      if (res.code === 0) {
        this.formData = {
          name: res.data.name,
          key: res.data.key,
          title_type: 2,
          type: res.data.type,
          value: res.data.value,
          show: res.data.show,
          pos: res.data.pos
        }
      }
    }
  }
}
</script>

<style>
</style>
